import { render, staticRenderFns } from "./YaMapPolygons.vue?vue&type=template&id=9a625c66&scoped=true&"
import script from "./YaMapPolygons.vue?vue&type=script&lang=js&"
export * from "./YaMapPolygons.vue?vue&type=script&lang=js&"
import style0 from "./YaMapPolygons.vue?vue&type=style&index=0&id=9a625c66&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a625c66",
  null
  
)

export default component.exports